window.loading = false;
let myValCount = 0;
window.defaultImage = '';
function addToBundle() {
    $('.mrk-add-product-to-bundle').unbind('click');

    $('.mrk-add-product-to-bundle').click(function(e) {
        e.preventDefault();
        const btn = $(this);
        btn.attr('aria-busy', true);
        const title = btn.attr('title');
        const image = btn.attr('image');
        const product_id = btn.attr('product_id');

        setTimeout(function() {
            btn.attr('aria-busy', false);
            disableButton(btn);

            // Remove all placeholders
            $('.mrk-product-list-new .mrk-placeholder').remove();

            // Append the clicked item
            appendItem(title, image, product_id);

            // Count real items
            const realItemCount = $('.mrk-product-list-new .product-item:not(.mrk-placeholder)').length;

            // Calculate placeholders needed
            const placeholdersNeeded = window.number_of_products - realItemCount;

            // Append necessary placeholders
            appendPlaceholders(placeholdersNeeded, window.defaultImage);

            updateCounter(window.number_of_products);
            checkBundle(true);
            removeAction();
            bindadBundle();
            updateProductTitles();
        }, 200);
    });
}

function appendItem(title, image, product_id) {
    const currentMonth = getCurrentMonth();
    const currentMonthMobile = getCurrentMonthMobile();
    const itemHTML = buildItemHTML(title, image, product_id, currentMonth, false,currentMonthMobile);
    $('.mrk-product-list-new').append(itemHTML);
}

function appendPlaceholders(count, image) {
    for (let i = 0; i < count; i++) {
        const placeholderMonth = getPlaceholderMonth(i);
        const placeholderHTML = buildItemHTML("Scent of the month", image, "placeholder_id", placeholderMonth, true);
        $('.mrk-product-list-new').append(placeholderHTML);
    }
}
function getCurrentMonth() {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentDate = new Date();
    let currentMonthIndex = currentDate.getMonth(); // 0 - 11 for Jan - Dec
    return monthNames[currentMonthIndex];
}

function getCurrentMonthMobile() {
    const monthNamesMobile = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const currentDate = new Date();
    let currentMonthIndex = currentDate.getMonth(); // 0 - 11 for Jan - Dec
    return monthNamesMobile[currentMonthIndex];
}

function getPlaceholderMonth(offset) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const currentDate = new Date();
    let currentMonthIndex = currentDate.getMonth(); // 0 - 11 for Jan - Dec
    currentMonthIndex = (currentMonthIndex + offset) % 12; // Adjust for overflow and offset
    return monthNames[currentMonthIndex];
}

function buildItemHTML(title, image, product_id, month, isPlaceholder,monthMobile) {
    const placeholderClass = isPlaceholder ? 'mrk-placeholder' : '';
    var mainImage = isPlaceholder ? `<div class="mrk-placeholder-image"></div>` : `<img src="${image}"/>`;
    return `<div class="product-item ${placeholderClass}" mobileMonth="${monthMobile}" title="${title}" product_id="${product_id}">
                <div class="product-remove-btn link text-xs"><svg role="presentation" stroke-width="2" focusable="false" width="20" height="20" class="icon icon-close" viewBox="0 0 24 24"><path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path></svg></div>
                <div class="product-content-new">
                   ${mainImage}
                    <div class="product-title h5 tes">${title}</div>
                    <div class="mrk-month-btn btn rounded-full">${month}</div>
                </div>
            </div>`;
}
function updateCounter(total){
    var current = $('.mrk-product-list-new .product-item:not(.mrk-placeholder)').length;
    $('.mrk-progress-counter').each(function() {
        const percent = (current * 100) / total;
        $(this).css({'--value': percent})
        $(this).find('.mrk-inner-progress').text(`${current}/${total}`);
    });
  if(current){
    $('.mrk-selected-products-list-title,.mrk-colored-rte,.mrk-rte-popup').show();
  }else
    $('.mrk-selected-products-list-title,.mrk-colored-rte,.mrk-rte-popup').hide();
}
function disableButton(btn){
    btn.prop('disabled', true).css('background-color','#763718');
    btn.parents('.mrk-form').addClass('mrk-form-disabled');
    console.log(!btn.hasClass('product-card__mobile-quick-buy-button'));
    if(!btn.hasClass('product-card__mobile-quick-buy-button')){
    btn.find('div').text('Added!');
    }

}
function enableButton(btn){
    if(!btn.hasClass('product-card__mobile-quick-buy-button')){
        btn.find('div').text('ADD TO QUEUE'); 
    }
    btn.prop('disabled', false).css('background-color','rgb(var(--button-background))');
    btn.parents('.mrk-form').removeClass('mrk-form-disabled');
}
function checkBundle(openPop){
    if($('.product-item').length > 0){
        $('.mrk-selected-products .empty-text').hide() 
    }else{
        $('.mrk-selected-products .empty-text').show()
    }
    if($('.mrk-product-list-new .product-item:not(.mrk-placeholder)').length == window.number_of_products){
        $('.mrk-final-add-subscribe').show().prop('disabled', false);
        $('.mrk-add-product-to-bundle').each(function(){
            $(this).addClass('disabled');
        });
    }else{
        $('.mrk-final-add-subscribe').show().prop('disabled', true);
        $('.mrk-add-product-to-bundle').each(function(){
            $(this).removeClass('disabled');
        }); 
    }
    if(openPop)
    setTimeout(openSubscriptionDrawer,250);
}
function removeAction(){
    $('.product-remove-btn').unbind('click');
    $('.product-remove-btn').click(function (e) { 
        e.preventDefault();
        const product_id = $(this).parents('.product-item').attr('product_id')
       // $(`.product-item[product_id="${product_id}"]`).each(function(){$(this).remove()});
        myValCount -= 1; // Decrease myValCount by 1
        $(`.product-item[product_id="${product_id}"]`).each(function(){
            $(this).remove();
        });
        // Remove all placeholders
        $('.mrk-product-list-new .mrk-placeholder').remove();
        // Count real items
        const realItemCount = $('.mrk-product-list-new .product-item:not(.mrk-placeholder)').length;

        // Calculate placeholders needed
        const placeholdersNeeded = window.number_of_products - realItemCount;
        // Append necessary placeholders
        appendPlaceholders(placeholdersNeeded, window.defaultImage);
        updateCounter(window.number_of_products)
        updateProductTitles();
        checkBundle();
        updateButtons();
        setTimeout(updateProductTitles,100)
    });
}
function bindadBundle(){
    $('.mrk-form-disabled').unbind('click');
    $('.mrk-form-disabled').click(function (e) { 
        e.preventDefault();
        const product_id = $(this).attr('product_id');
        $(`.product-item[product_id="${product_id}"] .product-remove-btn`).each(function(){
            $(this).click();
        })
    });
}
function updateProductTitles() {
    // Ensure monthIndex and monthNames are accessible in this scope
    let monthIndex = getInitialMonthIndex();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthNamesMobile = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    // Function to get the initial month index
    function getInitialMonthIndex() {
        const currentDate = new Date();
        let currentMonthIndex = currentDate.getMonth(); // 0 - 11 for Jan - Dec
        const currentDay = currentDate.getDate();

        // If current day is 25 or later, start from next month
        if (currentDay >= 25) {
            currentMonthIndex += 1;
        }

        return currentMonthIndex % 12; // Adjust for overflow
    }

    // Function to get the year based on the month index
    function getYearForMonth(index) {
        const currentYear = new Date().getFullYear();
        return currentYear + Math.floor((monthIndex + index) / 12);
    }

    // Loop through all product items and update their titles
    $('mrk-subscription-items-drawer .product-item').each(function (index) {
        const title = $(this).attr('title');
        const currentMonth = monthNames[(monthIndex + index) % 12];
        const currentMonthMobile = monthNamesMobile[(monthIndex + index) % 12];
        const year = getYearForMonth(index);
        $(this).find('.mrk-month-btn').html(`${currentMonth} ${year}`);
        $(this).attr('mobilemonth',currentMonthMobile);
    });

}

function openSubscriptionDrawer(){
    var products_names = '';

    $('.mrk-product-list-new .product-item:not(.mrk-placeholder)').each(function(index) {
        var monthName = $(this).attr('mobilemonth').trim();
        var titleText = $(this).attr('title').trim();
        var item = `<input type="hidden" name="properties[${monthName}]" value="${titleText}">`;
        products_names += item;
    });
    $('.mrk-custom-attributes').html('').html(products_names);
    // $('.mrk-monthly-yearly-selection')[0].scrollIntoView({ block: "center", behavior: "smooth" });
    if($('.mrk-product-list-new .product-item:not(.mrk-placeholder)').length){
        if(window.innerWidth > 769)
            document.querySelector('mrk-subscription-items-drawer').show();
        else
            document.querySelector('mrk-subscription-items-drawer').show();
            // document.querySelector('tester-drawer').show();
    }
};

$(document).on('mrk:addToCart',function(){
    document.querySelector('facet-drawer').hide();
    document.querySelector('mrk-subscription-items-drawer').hide();
    location.pathname = 'checkout';
    // document.querySelector('tester-drawer').hide();
});
$(document).on('mrk:filterStart',function(){
    window.mrk_selected_bundle = $('.mrk-product-list-new').html()
});
$(document).on('mrk:filterLoaded',function(){
    $('.mrk-product-list-new').html(window.mrk_selected_bundle);
    subscriptionSelection();
    addToBundle();
    checkBundle(false);
    updateButtons();
    checkScroll();
    removeAction();
    mrkAllReloads();
    updateCounter(window.number_of_products);
    setTimeout(function(){$('.mrk-custom-product-selection-toggle').prop('checked', true).trigger('change')},200);
});


function mrkAllReloads(){
    $('.mrk-search-form [type="reset"]').on('click', function(){
        setTimeout(function(){
            $('.mrk-search-form input[type="search"]').trigger('input');
        },150)
    });
    $('.mrk-final-add-subscribe').click(openSubscriptionDrawer);
    $('.mrk-search-form').on('submit', function(e){
        e.preventDefault();
        $('.mrk-search-form input[type="search"]').trigger('input')
    });
    $('.mrk-search-form input[type="search"]').on('input', function(e) {
        $('.mrk-subscription-page').addClass('is-loading');
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(function() {
            if (requestInProgress) {
                return;
            }
            e.preventDefault();
            var form = $('.mrk-search-form');
            if($('.mrk-search-form input[type="search"]').val().length>0){
                var url = form.attr('action') + '?' + form.serialize();
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).filter('.mrk-products').html();
                        const count = $(html).filter('.mrk-product-count').html();
                        const pagination = $(html).filter('.pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-product-count').html(count);
                        $('.mrk-pagination').html(pagination);
                        $('.mrk-subscription-page').removeClass('is-loading');
                        addToBundle();
                        checkBundle(false);
                        updateButtons();
                        checkScroll();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }else{
                var url = location.pathname+location.search;
                $('.mrk-subscription-page').addClass('is-loading');
                requestInProgress = true;
                $.ajax({
                    url: url,
                    method: 'get',
                    complete: function() {
                        requestInProgress = false;
                    },
                    success: function(response) {
                        var html = $.parseHTML(response);
                        const products = $(html).find('.mrk-product-list').html();
                        const pagination = $(html).find('.mrk-pagination').html();
                        $('.mrk-product-list').html(products);
                        $('.mrk-pagination').html(pagination);
                        $('.mrk-subscription-page').removeClass('is-loading');
                        addToBundle();
                        checkBundle(false);
                        updateButtons();
                        checkScroll();
                        if(products == ''){
                            $('.mrk-empty').show()
                        }else{
                            $('.mrk-empty').hide()
                        }
                    }
                });
            }
        }, 1000);  // Delay of 2 seconds
    });
    $('[aria-controls="mrk-subscription-items-drawer"]').click(function(){
        document.querySelector('mrk-subscription-items-drawer').show();
    })
}
var debounceTimeout;
var requestInProgress = false;


function updateButtons(){
    $('.mrk-add-product-to-bundle').each(function(){
        enableButton($(this));
    });
    $('.product-item').each(function(){
        const product_id = $(this).attr('product_id');
        $(`.mrk-add-product-to-bundle[product_id=${product_id}]`).each(function(){
            disableButton($(this));
        });
    });
    updatedCounts();
}
function updateData(){
    $('.mrk-bundle-items').each(function(){
        $(this).html('');
        checkBundle(true);
        updateButtons();
    });
    updatedCounts();
}
function updatedCounts(){
    $('[role="dialog"] .mrk-bundle-items .product-item .product-title .text-grey').each(function(index){
        var order = index + 1;
        $(this).html(`${order}.`);
    });
}
function mrkPagination(){
    window.loading = true;
    $('.mrk-subscription-page').addClass('is-loading');
    $('.mrk-loader').show();
    $('.mrk-load-more-btn').hide();
    $.ajax({
        url: $('.mrk-loader').attr('next-url'),
        method: 'get',
        success: function(response) {
            window.loading = false;
            var html = $.parseHTML(response);
            const products = $(html).find('.mrk-product-list').html();
            const pagination = $(html).find('.mrk-pagination').html();
            $('.mrk-product-list').append(products);
            $('.mrk-pagination').html(pagination);
            $('.mrk-subscription-page').removeClass('is-loading');
            $('.mrk-loader').hide();
            $('.mrk-load-more-btn').show();
            addToBundle();
            checkBundle(false);
            updateButtons();
            checkScroll()
        }
    });
}
function initSelectedProductScroll(){
    // Define the step size for each scroll
    var scrollStep = 300; // You can adjust this value

    // Handle click on the next button
    $('.mrk-selected-products-list-wrapper [is="next-button"]').click(function(e) {
        e.preventDefault();
        var $scrollCarousel = $('#'+$(this).attr('aria-controls'));
        // Animate scrolling to the right
        $scrollCarousel.animate({
            scrollLeft: '+=' + scrollStep
        }, 'smooth'); // Adjust 'smooth' to change the animation speed
    });

    // Handle click on the previous button
    $('.mrk-selected-products-list-wrapper [is="prev-button"]').click(function(e) {
        e.preventDefault();
        var $scrollCarousel = $('#'+$(this).attr('aria-controls'));
        // Animate scrolling to the left
        $scrollCarousel.animate({
            scrollLeft: '-=' + scrollStep
        }, 'smooth'); // Adjust 'smooth' to change the animation speed
    });
}
function checkScroll() {
    if ($('.mrk-pagination').length && $('.mrk-loader').attr('next-url') != undefined) {
        $('.mrk-load-more-btn').off('click');
        $('.mrk-load-more-btn').on('click', function(){
            if ($('.mrk-loader').attr('next-url') != undefined && window.loading == false) {
                $(window).off('scroll');
                mrkPagination();
            }
        });
    } else {
        $('.mrk-loader').hide();
    }
    
}
function subscriptionSelection(){
    $('[name="subscription_type"]').off();
    $('[name="subscription_type"]').on('change', function (e) { 
        e.preventDefault();
        var selected_Subscription = $('[name="subscription_type"]:checked').val();
        $('.mrk-step-2-subscription').show();
        $('.mrk-monthly-yearly-selection')[0].scrollIntoView({ block: "center", behavior: "smooth" });
        $('.mrk-gender').val(selected_Subscription);
    });
     $('.mrk-custom-product-selection-toggle').off();
    $('.mrk-custom-product-selection-toggle').on('change', function (e) { 
        e.preventDefault();
        var isChecked = $('.mrk-custom-product-selection-toggle').is(':checked');
        if(isChecked){
            $('.mrk-last-step-subscription').show();
            $('.mrk-last-step-subscription')[0].scrollIntoView({ block: "start", behavior: "smooth" });
            //$('.mrk-step-2-subscription').addClass('mrk-step-2-disabled');
        }else{
            $('.mrk-last-step-subscription').hide();
            $('.mrk-monthly-yearly-selection')[0].scrollIntoView({ block: "center", behavior: "smooth" });
            //$('.mrk-step-2-subscription').removeClass('mrk-step-2-disabled');
        }
    });
}
updateCounter(window.number_of_products);
checkScroll();
addToBundle();
mrkAllReloads();
subscriptionSelection();
initSelectedProductScroll()